export default __webpack_public_path__ + "static/media/tete86.b825a5dc.png";